<kt-portlet>
	<!-- <kt-portlet-header [title]="'Kullanıcı Listesi'">
			
	</kt-portlet-header> -->
	<kt-portlet-body>



		<!-- <div>
			<table>
				<thead>
					<th>AD</th>
					<th>SOYAD</th>
				</thead>
				<tbody>
					<tr *ngFor="let user of users">
						<td>{{user.name}}</td>
						<td>{{user.surname}}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<br>
		<div>
			<button class="btn btn-primary btn-small" (click)="test()">Test</button>
		</div> -->


	

		<div class="mat-table__wrapper">
			<div class="table-container mat-elevation-z8">
				<div style="text-align: center;width: 100%;">
				<mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
			</div>
			<table mat-table #table  [dataSource]="dataSource" >
				
				

				<ng-container matColumnDef="id">
					<mat-header-cell *matHeaderCellDef>#</mat-header-cell>
					<mat-cell *matCellDef="let user">
					<span class="mobile-label">UserId:</span>
						{{user.id}}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="userName">
					<mat-header-cell *matHeaderCellDef>USERNAME</mat-header-cell>
					<mat-cell class="duration-cell"
							*matCellDef="let user">
							<span class="mobile-label">User Name:</span>
							{{user.userName}}
						</mat-cell>
				</ng-container>
			
				<ng-container matColumnDef="fullName">
					<mat-header-cell *matHeaderCellDef>AD SOYAD</mat-header-cell>
					<mat-cell class="duration-cell"
							*matCellDef="let user">
							<span class="mobile-label">Ad Soyad:</span>
							{{user.fullName}}
						</mat-cell>
				</ng-container>

				<ng-container matColumnDef="emailAddress">
					<mat-header-cell *matHeaderCellDef>MAIL</mat-header-cell>
					<mat-cell class="duration-cell"
							*matCellDef="let user">
							<span class="mobile-label">Mail:</span>
							{{user.emailAddress}}
						</mat-cell>
				</ng-container>

				<ng-container matColumnDef="roleNames">
					<mat-header-cell *matHeaderCellDef>ROLES</mat-header-cell>
					<mat-cell class="duration-cell"
							*matCellDef="let user">
							<span class="mobile-label">Roles:</span>
							{{user.roleNames.toString()}}
						</mat-cell>
				</ng-container>

				<ng-container matColumnDef="actions">
					<mat-header-cell *matHeaderCellDef>ACTIONS</mat-header-cell>
					<mat-cell *matCellDef="let user">
						<button (click)="editUser(user.id)" mat-icon-button color="primary" matTooltip="Edit user">
							<mat-icon>create</mat-icon>
						</button>&nbsp;
						<button mat-icon-button color="warn" matTooltip="Delete user" type="button" (click)="deleteUser(user)">
							<mat-icon>delete</mat-icon>
						</button>
					</mat-cell>
				</ng-container>
				
				<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
				
				<mat-row *matRowDef="let row; columns: displayedColumns" (click)="onRowClicked(row)"></mat-row>
				
			</table>
		</div>
	</div>

		<div class="mat-table__bottom">
		
		</div>

		<div class="fab-container">
			<button mat-fab class="fab-toggler pull-right"
					>
			  <i class="material-icons">add</i>
			</button>
		</div>

	</kt-portlet-body>

</kt-portlet>